import { Form } from 'utils/hooks'
import { Flex } from 'components/shared/flex'
import { StomachTestResultV2Form } from 'api/result'
import { CheckboxField, DateField, MultipleSelectField, RangeField, SelectField } from 'components/shared/input'
import { ProductItem } from 'entities/product_item'
import { Symptom } from '../result_v2'

type StomachTestViewProps = {
    form: Form<StomachTestResultV2Form>
    formPrev: Form<StomachTestResultV2Form>
    formPrev2: Form<StomachTestResultV2Form>
    productItem: ProductItem
    symptoms: Symptom[]
}

export const StomachTestView = ({ form, formPrev, formPrev2, productItem, symptoms }: StomachTestViewProps) => {
    return (
        <>
            <div style={{ padding: 10 }}>
                <div>状態</div>
                <Flex style={{ fontSize: 14 }}>
                    <CheckboxField form={form} attr={'menstruation'} checkboxLabel="生理中" />
                    <CheckboxField form={form} attr={'pregnancy'} checkboxLabel="妊娠中" />
                </Flex>
            </div>
            <div style={{ padding: 10 }}>
                <div>疑いのある症状</div>

                <div style={{ fontSize: 14 }}>
                    <MultipleSelectField
                        id="stomach-symptoms"
                        form={form}
                        attr="symptoms"
                        selectItems={symptoms.filter((s) => s.products.includes('stomach')).map((s) => s)}
                        hideSearch
                        horizontal
                        hideSelectAll
                    />
                </div>
            </div>
            <div>
                <StomachControlForm form={form} title="今回" color="#9002" hideEnableCheck productItem={productItem} />
                <StomachControlForm form={formPrev} title="前回" color="#9002" productItem={productItem} />
                <StomachControlForm form={formPrev2} title="前々回" color="#9002" productItem={productItem} />
            </div>
        </>
    )
}
type StomachControlFormProps = {
    form: Form<StomachTestResultV2Form>
    title: string
    color: string
    hideEnableCheck?: boolean
    productItem: ProductItem
}

const StomachControlForm = ({ form, title, color, hideEnableCheck, productItem }: StomachControlFormProps) => {
    const enabled = form.object.enabled

    return (
        <div style={{ padding: 20, backgroundColor: color, width: '100%' }}>
            <Flex style={{}}>
                <div style={{ fontWeight: 'bold' }}>{title}</div>
                {!hideEnableCheck && (
                    <div>
                        <CheckboxField form={form} attr="enabled" checkboxLabel="有効" controlId={title} />
                    </div>
                )}
            </Flex>
            {form.object.enabled && (
                <>
                    <Flex>
                        <DateField form={form} attr="deliveryDate" label="検査日" style={{ marginBottom: 0 }} />
                    </Flex>
                    {form.object.useCt ? (
                        <div>
                            <div style={{ backgroundColor: '#fff5', padding: 5 }}>
                                <div style={{ fontWeight: 'bold' }}>HK</div>
                                <div style={{ padding: 10 }}>
                                    {productItem.qcVersion?.protocolVersionProbes
                                        ?.filter((pvp) => pvp.qcType === 'HK')
                                        .map((pvp, index) => {
                                            return (
                                                <RangeField
                                                    key={'range-' + index}
                                                    form={form}
                                                    attr={['hkCts', pvp.probe!.name!]}
                                                    min={0}
                                                    max={40}
                                                    label={`${pvp.probe?.name} CT =`}
                                                    showValue
                                                    step={0.01}
                                                />
                                            )
                                        })}
                                </div>
                            </div>
                            <div style={{ backgroundColor: '#fff5', marginTop: 10, padding: 5 }}>
                                <div style={{ fontWeight: 'bold' }}>Bio marker</div>
                                <div style={{ padding: 10 }}>
                                    {productItem.currentProtocolVersion?.protocolVersionProbes?.map((pvp, index) => {
                                        return (
                                            <RangeField
                                                key={'range-' + index}
                                                form={form}
                                                attr={['markerCts', pvp.probe!.name!]}
                                                min={0}
                                                max={40}
                                                label={`${pvp.probe?.name} CT =`}
                                                showValue
                                                step={0.01}
                                            />
                                        )
                                    })}
                                </div>
                            </div>
                        </div>
                    ) : (
                        <RangeField
                            form={form}
                            attr="baseScore"
                            label="機械学習スコア"
                            min={0}
                            max={1}
                            step={0.001}
                            disabled={!enabled}
                            style={{ marginBottom: 0 }}
                            showValue
                        />
                    )}
                    <RangeField form={form} attr="age" label="年齢" disabled={!enabled} min={0} max={100} step={5} style={{ marginBottom: 0 }} showValue />
                    <Flex>
                        <RangeField
                            form={form}
                            attr="height"
                            label="身長"
                            disabled={!enabled}
                            min={100}
                            max={200}
                            step={5}
                            style={{ marginBottom: 0 }}
                            showValue
                        />
                        <RangeField
                            form={form}
                            attr="weight"
                            label="体重"
                            disabled={!enabled}
                            min={30}
                            max={120}
                            step={5}
                            style={{ marginBottom: 0 }}
                            showValue
                        />
                    </Flex>
                    <Flex>
                        <SelectField
                            form={form}
                            attr="smoking"
                            label="喫煙歴"
                            selectItems={[
                                { label: 'なし', value: 'never' },
                                { label: '過去に吸っていた', value: 'ever' },
                                { label: '吸っている', value: 'now' },
                            ]}
                        />
                    </Flex>
                    {form.object.smoking === 'ever' && (
                        <Flex>
                            <RangeField form={form} attr="noSmokingPeriod" label="禁煙年数" showValue min={0} max={20} />
                        </Flex>
                    )}

                    <Flex>
                        <SelectField
                            form={form}
                            attr="eatingHabitsOfSaltedFood"
                            label="塩蔵品の食習慣"
                            selectItems={[
                                { label: 'あまり食べない(~週2日)', value: 'unusual' },
                                { label: 'ときどき食べる(週3日~5日)', value: 'sometimes' },
                                { label: 'よく食べる(週6日以上)', value: 'everyday' },
                            ]}
                        />
                    </Flex>
                    <div style={{ marginTop: 10 }}>
                        <div>
                            <div>既往歴</div>
                            <div>
                                <CheckboxField
                                    form={form}
                                    attr="helicobacter"
                                    checkboxLabel="ヘリコバクター・ピロリ感染"
                                    disabled={!enabled}
                                    controlId={title}
                                    style={{ marginBottom: 0 }}
                                />
                                <CheckboxField
                                    form={form}
                                    attr="chronicGastritis"
                                    checkboxLabel="慢性胃炎"
                                    disabled={!enabled}
                                    controlId={title}
                                    style={{ marginBottom: 0 }}
                                />
                                <CheckboxField
                                    form={form}
                                    attr="gastricUlcer"
                                    checkboxLabel="胃潰瘍"
                                    disabled={!enabled}
                                    controlId={title}
                                    style={{ marginBottom: 0 }}
                                />
                            </div>
                        </div>
                        <div style={{ marginTop: 10 }}>
                            <div>家族歴</div>
                            <div>
                                <CheckboxField form={form} attr="stomachFamilyHistory" checkboxLabel="胃がんの家族歴あり" />
                            </div>
                        </div>
                    </div>
                </>
            )}
        </div>
    )
}
